import React, { useRef } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { CButton, CNav, CNavItem, CNavLink } from "@coreui/react";
import AntdTable from "src/components/AntdTable/Table";
import { clubDocumentsAction } from "src/store/Slices/Documents/ClubDocumentsSlice";
import { Button, Dropdown, Input, Space, Switch } from "antd";
import { DeleteOutlined, DownOutlined } from "@ant-design/icons";
import { SearchOutlined } from "@ant-design/icons";
import EditClubDocumentModal from "./Modals/EditClubDocumentModal";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const ClubDocuments = ({ mnemo }) => {
    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [documentInfo, setDocumentInfo] = useState();
    const [selectedKeys, setSelectedKyes] = useState("");
    const [dataIndex, setDataIndex] = useState("");
    const [sortByIdFrom, setSortByIdFrom] = useState();
    const [sortByIdTo, setSortByIdTo] = useState();
    const [isDeleted, setIsDeleted] = useState(false);
    const [isOpenEditModal, setIsOpenEditModal] = useState(false);

    const items = [
        {
            key: "1",
            label: "Редактировать",
            onClick: () => {
                setIsOpenEditModal(true);
            },
            disabled: !mnemo?.children?.find(
                (ele) => ele.mnemo === "updateBtn"
            ),
        },
    ];

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "id", title: "Документ клуба" },
        {
            label: "По наименованию",
            value: 2,
            index: "documentName",
            title: "Наименование",
        },
        {
            label: "По имени файла",
            value: 3,
            index: "fileName",
            title: "Имя файла",
        },
    ];

    const searchInput = useRef(null);

    // STORE
    const clubDocumentsList = useSelector(
        (state) => state.ClubDocumentsSlice.clubDocumentsList
    );
    const clubDocumentsListLoading = useSelector(
        (state) => state.ClubDocumentsSlice.clubDocumentsListLoading
    );
    useEffect(() => {
        dispatch(clubDocumentsAction({ flag: "get" }));
    }, []);

    const title = () => {
        return (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                    }}
                >
                    <CNav variant="tabs">
                        <CNavItem>
                            <CNavLink
                                style={{ cursor: "pointer" }}
                                active={true}
                            >
                                Документы клубов
                            </CNavLink>
                        </CNavItem>
                    </CNav>
                </div>
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                    }}
                >
                    <Switch
                        //disabled={(!mnemo?.children?.find(el => el.name === 'Справочник')?.children.find(ele => ele.mnemo === 'isDeletedBtn'))}
                        defaultValue={isDeleted}
                        checkedChildren={<DeleteOutlined />}
                        unCheckedChildren={<DeleteOutlined />}
                        onChange={() => {
                            setIsDeleted(!isDeleted);
                        }}
                    />
                </div>
            </div>
        );
    };

    const onClickRowOne = (record) => {
        setDocumentInfo(record);
    };

    const handleTableChange = (pagination, filters, sorter) => {
        dispatch(
            clubDocumentsAction({
                flag: "get",
                value: {
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys && selectedKeys[0],
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const handleReset = (clearFilters) => {
        setPage(1);
        setPageSize(20);
        dispatch(clubDocumentsAction({ flag: "get" }));
        setSelectedKyes();
        setDataIndex();
        clearFilters();
        setSortByIdFrom();
        setSortByIdTo();
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        setSelectedKyes(selectedKeys[0]);
        setDataIndex(dataIndex);
        dispatch(
            clubDocumentsAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    const getColumnSearchProps = (dataIndex, title) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <div>
                    {
                        <Input
                            ref={searchInput}
                            placeholder={`Искать ${title}`}
                            value={selectedKeys[0]}
                            onChange={(e) =>
                                setSelectedKeys(
                                    e.target.value ? [e.target.value] : []
                                )
                            }
                            onPressEnter={() =>
                                onClickSearchItem(selectedKeys, dataIndex)
                            }
                            style={{
                                marginBottom: 8,
                                display: "block",
                            }}
                        />
                    }
                </div>
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            onClickSearchItem(selectedKeys, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Искать
                    </Button>
                    <Button
                        onClick={() => {
                            if (clearFilters) {
                                handleReset(clearFilters);
                            }
                        }}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Сбросить
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        Закрыть
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? "#1677ff" : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => text,
    });

    const rowClassName = (record) => {
        return record?.key === documentInfo?.key ? "selected-row" : "";
    };

    const clickOnAction = (element) => {
        setDocumentInfo(element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            clubDocumentsAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    useEffect(() => {
        dispatch(
            clubDocumentsAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys && selectedKeys[0],
                    idFrom: sortByIdFrom,
                    idTo: sortByIdTo,
                },
            })
        );
    }, [isDeleted]);

    const formatedRows = clubDocumentsList?.data?.value?.rows.map((element) => {
        return {
            ...element,
            fileName: (
                <a
                    href={`http://83.220.173.243/Content/${element.fileName}`}
                    target="_blank"
                >
                    {element.fileName}
                </a>
            ),
        };
    });

    return (
        <>
            <EditClubDocumentModal
                visible={isOpenEditModal}
                setVisible={setIsOpenEditModal}
                documentInfo={documentInfo}
            />
            {window.innerWidth >= 768 ? (
                <AntdTable
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    page={page}
                    setPage={setPage}
                    loading={clubDocumentsListLoading}
                    columns={
                        clubDocumentsList && [
                            ...clubDocumentsList?.data?.value?.columns.map(
                                (element) => {
                                    return {
                                        ...element,
                                        ...getColumnSearchProps(
                                            element.dataIndex,
                                            element.title
                                        ),
                                    };
                                }
                            ),
                            {
                                title: "Действия",
                                key: "action",
                                align: "center",
                                render: (_, record) => {
                                    return (
                                        <Dropdown
                                            menu={{
                                                items,
                                            }}
                                            disabled={isDeleted}
                                        >
                                            <a className="text-primary text-decoration-none">
                                                Действия <DownOutlined />
                                            </a>
                                        </Dropdown>
                                    );
                                },
                                width: 100,
                            },
                        ]
                    }
                    rows={formatedRows}
                    scroll={{ x: 0, y: 226 }}
                    title={title}
                    onClickRowOne={onClickRowOne}
                    onChange={handleTableChange}
                    total={clubDocumentsList?.data?.value?.totalCount}
                    rowClassName={rowClassName}
                />
            ) : (
                <AntdMobileTable
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={clubDocumentsList}
                    elementsListLoading={clubDocumentsListLoading}
                    setIsOpenAddEditModal={""}
                    handlePaginationChange={handlePaginationChange}
                    onChange={handleTableChange}
                    clickOnAction={clickOnAction}
                    items={items}
                    filterOptionsArr={filterOptionsArr}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default ClubDocuments;
